import type { TModule } from '@modules/core/types';

import { HOME_ROUTE_PATHS } from './config';
import { DASHBOARD_ROUTES } from './dashboard';

/**
 * Represents the "Home" module.
 *
 * @remarks
 * This module encapsulates the routing and permissions configuration for `home` related features.
 *
 * @property id - A unique identifier for the module ("home").
 * @property permissions - The access control configuration that restricts module access,
 *                         allowing only users with the appropriate roles or scopes.
 * @property routes - An array that lists the routes for the module.
 */

const homeModule: TModule = {
  id: 'home',
  fallbackRoute: [HOME_ROUTE_PATHS.dashboard],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...DASHBOARD_ROUTES],
};

export { HOME_ROUTE_PATHS as HomeRoutePaths };

export default homeModule;
